/**
 * This function is used to replace a script tag in HTML with a new script tag.
 */
export const updateHTML = (
  html: string,
  scriptSrc: string,
  newScriptHTML: string
) => {
  const srcsToMatch = [scriptSrc];

  // Also match protocol-relative versions for http/https URLs
  if (scriptSrc.startsWith('http')) {
    srcsToMatch.push(scriptSrc.replace(/^https?:/, ''));
  }

  const srcPatterToMatch = srcsToMatch
    .map((src) => src.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('|');

  // Regex that matches script tags with the given src(s) attribute
  // This handles variations in whitespace and attribute order and matches both absolute and protocol-relative URLs
  const scriptRegexPattern = `<script[^>]*?src=["'](${srcPatterToMatch})["'][^>]*?>.*?</script>`;
  const scriptRegex = new RegExp(scriptRegexPattern, 'gs');

  // Find the exact script tag match in the HTML
  const match = html.match(scriptRegex);
  if (match && match[0]) {
    // In one of the code samples `$&/` string in the replacement script started acting weird on attempt
    // to do `str.replace(old, replacement)`. This is a workaround for that.
    // Surprisingly, it also fixes with interpreting script containing strings like `<it()-at&&(d=d}function` as valid dom nodes (when later on inserted in the dom)
    return html.split(match[0]).join(newScriptHTML);
  }

  return html;
};
